import script from "./Quotation.vue?vue&type=script&setup=true&lang=js"
export * from "./Quotation.vue?vue&type=script&setup=true&lang=js"

import "./Quotation.vue?vue&type=style&index=0&id=909da9be&lang=scss"

const __exports__ = script;

export default __exports__